import React from 'react';
import './App.css';
import Routing from './routes';

import "./assets/css/materialdesignicons.min.css"
import "./assets/css/pe-icon-7-stroke.min.css"
import "./assets/css/bootstrap.min.css"

const App = () => {
  return (
    <React.Fragment>
      <Routing />
    </React.Fragment>
  );
}

export default App;
